<div class="spinner" [class]="getClasses()" data-testid="spinner" [attr.data-state]="state()">
    <div class="spinner__holder">
        @if (state() === 'loading') {
            <div class="spinner__circle" data-testid="spinner-circle"></div>
        } @else if (state() === 'completed') {
            <div class="spinner__icon">
                <ap-icon size="100% 100%" name="checkmark" color="success" data-testid="spinner-icon"> </ap-icon>
            </div>
        } @else if (state() === 'failed') {
            <div class="spinner__icon spinner__icon--failed">
                <ap-icon size="100% 100%" name="exclamation" color="error" data-testid="spinner-icon"> </ap-icon>
            </div>
        }

        <div
            class="spinner__text"
            aria-live="polite"
            role="status"
            [ngClass]="{ 'ap-sr-only': visuallyHiddenLabel() }"
            data-testid="spinner-text"
        >
            @if (state() === 'loading') {
                {{ text() }}
            } @else if (state() === 'completed') {
                {{ readyText() }}
            } @else if (state() === 'failed') {
                {{ failedText() }}
            }
        </div>
    </div>
</div>
